import { Reducer } from 'redux';

import {
    ActionTypes,
    UsersState,
    CheckIfUserIsActivatedSuccessAction,
    CheckIfUserIsActivatedErrorAction,
} from './types';

const defaultState = {
    userRegistrationCheck: {
        loading: false,
    },
};

const reducer: Reducer<UsersState> = (state = defaultState, action): UsersState => {
    switch (action.type) {
        case ActionTypes.CHECK_USER_REGISTRATION: {
            return {
                ...state,
                userRegistrationCheck: {
                    loading: true,
                    userStatus: undefined,
                    errorMessage: undefined,
                },
            };
        }
        case ActionTypes.CHECK_USER_REGISTRATION_SUCCESS: {
            const typedAction = action as CheckIfUserIsActivatedSuccessAction;
            const userStatus = typedAction.payload;
            return {
                ...state,
                userRegistrationCheck: {
                    loading: false,
                    userStatus,
                    errorMessage: undefined,
                },
            };
        }
        case ActionTypes.CHECK_USER_REGISTRATION_ERROR: {
            const typedAction = action as CheckIfUserIsActivatedErrorAction;
            const { errorMessage } = typedAction.payload;
            return {
                ...state,
                userRegistrationCheck: {
                    loading: false,
                    userStatus: undefined,
                    errorMessage,
                },
            };
        }
        default:
            return state;
    }
};

export { reducer as users };

export default reducer;
